import * as R from 'ramda';

function checkFeatureFlagStatus({ flags, featureFlagName }) {
    return R.compose(Boolean, R.propOr(false, featureFlagName))(flags);
}

export default checkFeatureFlagStatus;
